import React from 'react'
import PropTypes from 'prop-types'
import {
  FormControl,
  Radio,
  RadioGroup as MuiRadioGroup,
  FormControlLabel,
  FormLabel,
  FormHelperText,
} from '@mui/material'
import { Controller } from 'react-hook-form'

const RadioGroup = ({ name, label, control, defaultValue, items, row, radioGroupProps, ...restProps }) => {
  const labelId = `${name}-label`
  return (
    <FormControl sx={{ width: '100%' }} {...restProps}>
      {label && <FormLabel id={labelId}>{label}</FormLabel>}
      <Controller
        render={({ field }) => (
          <MuiRadioGroup row={row} {...field} defaultValue={defaultValue} {...radioGroupProps}>
            {items.map(item => (
              <FormControlLabel key={item?.id} value={item?.id} control={<Radio />} label={item?.name} />
            ))}
          </MuiRadioGroup>
        )}
        name={name}
        control={control}
      />
      <FormHelperText>{restProps?.error ? 'This field is required' : ''}</FormHelperText>
    </FormControl>
  )
}

RadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  control: PropTypes.instanceOf(Object).isRequired,
  items: PropTypes.array,
  row: PropTypes.bool,
  radioGroupProps: PropTypes.object,
}

RadioGroup.defaultProps = {
  defaultValue: '',
  items: [],
  row: false,
  radioGroupProps: {},
}

export default RadioGroup
